var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 16,
    viewBox: "0 0 108 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23367 8.03241L102.242 8.17033",
    stroke: "#CACACA",
    strokeWidth: 0.836813,
    strokeLinecap: "square",
    strokeDasharray: "1.67 4.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0789 15.6044H52.7317L56.8637 9.24466L61.4088 9.24466C62.0948 9.24466 62.6484 8.71204 62.6484 8.0522C62.6484 7.39237 62.0948 6.85975 61.4088 6.85975L56.8637 6.85975L52.7317 0.5L51.0789 0.5L53.1449 6.85978L48.5998 6.85978L47.3602 5.26983H46.1206L46.947 8.05224L46.1206 10.8346H47.3602L48.5998 9.24466H53.1449L51.0789 15.6044Z",
    fill: "#1262AE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.33008,
    cy: 8,
    r: 3.66319,
    fill: "white",
    stroke: "#1262AE",
    strokeWidth: 1.67363
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.102 8.68406C107.102 10.5024 105.56 12.0313 103.59 12.0313C101.619 12.0313 100.077 10.5024 100.077 8.68406C100.077 6.8657 101.619 5.33681 103.59 5.33681C105.56 5.33681 107.102 6.8657 107.102 8.68406Z",
    fill: "white",
    stroke: "#1262AE",
    strokeWidth: 1.67363
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneicon);
export default __webpack_public_path__ + "static/media/planeicon.47381fb1f20e95ae439ceae0c6bb3f25.svg";
export { ForwardRef as ReactComponent };